export default __webpack_public_path__ + "static/media/product-6.dfa56c00.jpg";